import { LoaderCircle } from 'lucide-react';

export function FullScreenLoader({ label = 'Cargando…' }: { label?: string }) {
  return (
    <div className="flex min-h-dvh items-center justify-center gap-2 text-muted-foreground">
      <LoaderCircle className="size-5 animate-spin" />
      <span className="text-sm">{label}</span>
    </div>
  );
}

export function Spinner({ className = 'size-4' }: { className?: string }) {
  return <LoaderCircle className={`${className} animate-spin`} />;
}
